<template>
    <div class="d-flex">
        <b-button
            v-if="!isEditable || isOnlineReview"
            @click="$bvModal.show(responseModalId)"
            class="mr-2 text-primary"
            variant="default"
            :class="{ 'text-secondary': hasResponse }"
            title="Host Response"
        >
            <font-awesome-icon :icon="['fas', 'reply']" />
        </b-button>
        <b-button title="Edit Review" @click="$bvModal.show(editModalId)" class="mr-2" variant="default">
            <font-awesome-icon :icon="['fas', 'edit']" />
        </b-button>
        <b-button title="Delete Review" @click="$bvModal.show(deleteModalId)" variant="default">
            <font-awesome-icon :icon="['fas', 'trash']" />
        </b-button>
        <modal @ok.prevent="deleteReview" :id="deleteModalId" title="Delete review">
            Are you sure you want to delete this review?
        </modal>
        <create-edit-review-modal
            :modalId="editModalId"
            :title="editModalTitle"
            :initValues="values"
            @submit="editReview"
            :properties="properties"
            :isReadOnly="!isEditable"
            :languages="languages"
            :isOnlineReview="isOnlineReview"
        />
        <modal @shown="onShowModal" size="lg" :id="responseModalId" title="Host Response">
            <b-alert v-if="isAirbnbReviewExpired" show variant="danger">
                The 14-day window to respond to a guest review has expired.
            </b-alert>
            <b-alert v-if="isAirbnbReviewExpiresSoon" show variant="warning">
                Possibility to send review will expire soon.
            </b-alert>
            <div class="d-flex flex-column">
                <form-textarea :disabled="true" v-model="guestReview" floatingLabel="Guest Review" rows="5" />
                <div class="d-flex mb-4">
                    <span>Rating:</span>&nbsp;<star-rating :readOnly="true" :value="Number(guestRating)" />
                </div>
            </div>
            <form-textarea :disabled="airnbnReviewHasResponse" v-model="message" floatingLabel="Response: " rows="5" />

            <template #modal-footer>
                <b-button
                    v-if="!isAirbnbReview"
                    variant="danger"
                    class="px-3"
                    @click="$bvModal.show(responseDeleteModalId)"
                    :disabled="!params.data.host_response"
                    >Delete</b-button
                >
                <b-button variant="warning" class="px-3" @click="$bvModal.hide(responseModalId)">Cancel</b-button>
                <b-button variant="primary" class="px-3" :disabled="isSendResponseDisabled" @click="submitResponse"
                    >Submit</b-button
                >
            </template>
            <modal
                ok-title="Delete"
                hide-backdrop
                title="Delete Response"
                :id="responseDeleteModalId"
                @ok.prevent="deleteResponse"
            >
                Are you sure you want to delete this response?
            </modal>
        </modal>
    </div>
</template>

<script>
import unescape from 'lodash/unescape';
import formTextarea from '../../generic/form-textarea/form-textarea.vue';
import modal from '../../generic/modal/modal.vue';
import starRating from '../../generic/star-rating/star-rating.vue';
import CreateEditReviewModal from '../../property/setup/reviews/create-edit-review-modal.vue';
import { REVIEW_STATUS_EXPIRES_SOON, REVIEW_STATUS_PENDING, REVIEW_STATUS_EXPIRED } from '../../../constants';
import responsiveButton from '../../generic/responsive-button/responsive-button.vue';
export default {
    components: { modal, CreateEditReviewModal, starRating, formTextarea, responsiveButton },
    data() {
        return {
            values: null,
            properties: [],
            languages: [],
            message: '',
            REVIEW_STATUS_EXPIRES_SOON,
            REVIEW_STATUS_PENDING,
        };
    },
    computed: {
        isSendResponseDisabled() {
            return (
                !this.message ||
                this.params.data.review_response_status === REVIEW_STATUS_EXPIRED ||
                this.airnbnReviewHasResponse
            );
        },
        isAirbnbReviewExpired() {
            return this.params.data.review_response_status === REVIEW_STATUS_EXPIRED;
        },
        isAirbnbReviewExpiresSoon() {
            return this.params.data.review_response_status === REVIEW_STATUS_EXPIRES_SOON;
        },
        isEditable() {
            return !['airbnb'].includes(this.params.data.source.toLowerCase());
        },
        isOnlineReview() {
            return ['online', 'staylio'].includes(this.params.data.source.toLowerCase());
        },
        deleteModalId() {
            return 'delete-review-modal-id-' + this.params.data.id;
        },
        editModalTitle() {
            return `Edit Review`;
        },
        editModalId() {
            return 'edit-modal-id-' + this.params.data.id;
        },
        responseModalId() {
            return 'response-modal-id-' + this.params.data.id;
        },
        guestReview() {
            return unescape(this.params.data.description);
        },
        guestRating() {
            return this.params.data.stars;
        },
        hasResponse() {
            return !!this.params.data.host_response;
        },
        airnbnReviewHasResponse() {
            return !!this.params.data.airbnb_review_id && this.params.data.host_response;
        },
        responseDeleteModalId() {
            return 'response-delete-modal-id-' + this.params.data.id;
        },
        isAirbnbReview() {
            return !!this.params.data.airbnb_review_id;
        },
    },
    mounted() {
        this.values = {
            ...this.params.data,
            title: unescape(this.params.data.title),
            description: unescape(this.params.data.description),
            rental_property: this.params.data.rental_property.id,
            language: this.params.data.language?.code || 'en',
        };
        this.properties = this.params.properties;
        this.languages = this.params.languages;
    },
    methods: {
        deleteReview() {
            this.params.deleteReview(this.params.data.id, this.modalId);
        },
        deleteResponse() {
            this.params.deleteResponse(this.params.data.id, this.responseDeleteModalId);
        },
        editReview(values) {
            this.params.editReview({ ...values }, this.editModalId);
        },
        submitResponse() {
            this.params.submitResponse &&
                this.params.submitResponse(
                    this.message,
                    this.params.data.id,
                    this.modalId,
                    !!this.params.data.airbnb_review_id
                );
        },
        onShowModal() {
            this.message = this.params.data.host_response?.message || '';
        },
    },
};
</script>

<style>
</style>